export const APP_COLORS = {
  PRIMARY: "#4A24AC",
  PRIMARY_LIGHT: "#A596D5",
  ACCENT: "#DBDA1F",
  TEXT: "#363C56",
  LIGHT: "#ffffff",
  LIGHT_2: "#fbfcfe",
  LIGHT_3: "#EBE8F6",
  LIGHT_4: "#E1E1E1",
  DARK: "#000000",
  PINK: "#FF306E",
  TEAL: "#27C1BC",
  BlUE_GRAY: "#51566A",
  CHART_PRIMARY: "#4A2CA9",
  CHART_PRIMARY_LIGHT: "#A596D5"
};
